var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g5, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatasetCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4388 66.1195V62.9116L88.2741 61.7635C87.6619 65.2838 83.306 67.6053 79.6686 68.0865L54.8725 81.8891L44.0491 85.6036L9.51193 68.6437L10.3104 68.2047C7.35613 66.8962 5.76811 63.8908 4.17122 61.1556L1.84686 62.4726L0.462891 62.844V66.2377C0.462891 67.6982 1.47425 69.1586 3.50585 70.273L38.114 89.2843C42.1683 91.513 48.7599 91.513 52.8143 89.2843L87.4224 70.273C89.4185 69.1755 90.4299 67.7488 90.4565 66.3052C90.4388 66.2461 90.4388 66.1786 90.4388 66.1195Z",
    fill: "url(#paint0_radial_1652_7816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.669 68.0867L54.8728 81.8893L45.4512 85.1226V90.956C48.1127 90.956 50.7741 90.3988 52.7969 89.2845L87.405 70.2732C89.4011 69.1757 90.4125 67.749 90.4391 66.3054C90.4391 66.2379 90.4391 66.1788 90.4391 66.1113H90.448V62.9033L88.4696 61.8565H88.2656C87.5736 65.3262 83.2708 67.614 79.669 68.0867Z",
    fill: "#B12BC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1054 85.9583L3.49729 66.947C-0.557039 64.7183 -0.557039 61.0967 3.49729 58.8764L38.1054 39.8651C42.1598 37.6364 48.7514 37.6364 52.8057 39.8651L87.4138 58.8764C91.4682 61.1051 91.4682 64.7267 87.4138 66.947L52.8057 85.9583C48.7514 88.187 42.1509 88.187 38.1054 85.9583Z",
    fill: "url(#paint1_linear_1652_7816)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1054 85.9583L3.49729 66.947C-0.557039 64.7183 -0.557039 61.0967 3.49729 58.8764L38.1054 39.8651C42.1598 37.6364 48.7514 37.6364 52.8057 39.8651L87.4138 58.8764C91.4682 61.1051 91.4682 64.7267 87.4138 66.947L52.8057 85.9583C48.7514 88.187 42.1509 88.187 38.1054 85.9583Z",
    fill: "#8F26F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1054 85.9583L3.49729 66.947C-0.557039 64.7183 -0.557039 61.0967 3.49729 58.8764L38.1054 39.8651C42.1598 37.6364 48.7514 37.6364 52.8057 39.8651L87.4138 58.8764C91.4682 61.1051 91.4682 64.7267 87.4138 66.947L52.8057 85.9583C48.7514 88.187 42.1509 88.187 38.1054 85.9583Z",
    fill: "#6157C9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1054 85.9583L3.49729 66.947C-0.557039 64.7183 -0.557039 61.0967 3.49729 58.8764L38.1054 39.8651C42.1598 37.6364 48.7514 37.6364 52.8057 39.8651L87.4138 58.8764C91.4682 61.1051 91.4682 64.7267 87.4138 66.947L52.8057 85.9583C48.7514 88.187 42.1509 88.187 38.1054 85.9583Z",
    fill: "url(#paint2_radial_1652_7816)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4048 66.9471L52.7967 85.9584C48.7423 88.1871 42.1507 88.1871 38.0964 85.9584L3.49713 66.9471C1.68732 65.951 0.684826 64.6762 0.498522 63.3762C0.258988 64.9886 1.26148 66.6432 3.49713 67.8757L38.1053 86.887C42.1596 89.1157 48.7512 89.1157 52.8055 86.887L87.4137 67.8757C89.6582 66.6432 90.6518 64.9886 90.4123 63.3762C90.2171 64.6847 89.2146 65.9594 87.4048 66.9471Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1652_7816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 38,
    width: 91,
    height: 50
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1054 85.9583L3.49729 66.947C-0.557039 64.7183 -0.557039 61.0967 3.49729 58.8764L38.1054 39.8651C42.1598 37.6364 48.7514 37.6364 52.8057 39.8651L87.4138 58.8764C91.4682 61.1051 91.4682 64.7267 87.4138 66.947L52.8057 85.9583C48.7514 88.187 42.1509 88.187 38.1054 85.9583Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1652_7816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.2398L34.7783 77.5583V88.9212L45.1137 94.5942L55.4492 88.9212V77.5583L45.1137 83.2398Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 94.5942L34.7783 88.9212V77.5583L45.1137 83.2398V94.5942Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 88.9212L45.1138 94.5942V83.2398L55.4492 77.5583V88.9212Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.2398L34.7783 77.5584L45.1137 71.8854L55.4492 77.5584L45.1137 83.2398Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.24L35.2308 77.8118L34.7783 78.0566L45.1137 83.7296L55.4492 78.0566L55.0056 77.8118L45.1137 83.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5252L48.21 84.8522V96.2066L58.5454 101.888L68.8808 96.2066V84.8522L58.5454 90.5252Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 101.888L48.21 96.2066V84.8522L58.5454 90.5252V101.888Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8808 96.2066L58.5454 101.888V90.5252L68.8808 84.8522V96.2066Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5251L48.21 84.8521L58.5454 79.1707L68.8808 84.8521L58.5454 90.5251Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5251L48.6535 85.0969L48.21 85.3417L58.5454 91.0232L68.8808 85.3417L68.4284 85.0969L58.5454 90.5251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 97.8192L61.6328 92.1378L71.9682 86.4648L82.3037 92.1378L71.9682 97.8192Z",
    fill: "url(#paint3_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.0231L21.3555 85.3416V96.6961L31.6909 102.378L42.0263 96.6961V85.3416L31.6909 91.0231Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 102.378L21.3555 96.6961V85.3416L31.6909 91.0231V102.378Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 96.6961L31.6909 102.378V91.0231L42.0263 85.3416V96.6961Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.0232L21.3555 85.3418L31.6909 79.6688L42.0263 85.3418L31.6909 91.0232Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.023L21.8079 85.5864L21.3555 85.8397L31.6909 91.5127L42.0263 85.8397L41.5827 85.5864L31.6909 91.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 98.309L34.7783 92.636L45.1137 86.9546L55.4492 92.636L45.1137 98.309Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 98.8069L7.93311 93.1255L18.2685 87.444L28.604 93.1255L18.2685 98.8069Z",
    fill: "url(#paint4_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.1711L34.7783 62.4896V73.8441L45.1137 79.5255L55.4492 73.8441V62.4896L45.1137 68.1711Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 79.5255L34.7783 73.8441V62.4896L45.1137 68.1711V79.5255Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 73.8441L45.1138 79.5255V68.1711L55.4492 62.4896V73.8441Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.171L34.7783 62.4895L45.1137 56.8165L55.4492 62.4895L45.1137 68.171Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.171L35.2308 62.7344L34.7783 62.9876L45.1137 68.6606L55.4492 62.9876L55.0056 62.7344L45.1137 68.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.4565L48.21 69.7834V81.1379L58.5454 86.8109L68.8808 81.1379V69.7834L58.5454 75.4565Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 86.8109L48.21 81.1379V69.7834L58.5454 75.4565V86.8109Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8808 81.1379L58.5454 86.8109V75.4565L68.8808 69.7834V81.1379Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.4564L48.21 69.7834L58.5454 64.102L68.8808 69.7834L58.5454 75.4564Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.4567L48.6535 70.0285L48.21 70.2733L58.5454 75.9548L68.8808 70.2733L68.4284 70.0285L58.5454 75.4567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 82.7502L61.6328 77.0687V88.4232L71.9682 94.1046L82.3037 88.4232V77.0687L71.9682 82.7502Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 94.1046L61.6328 88.4232V77.0687L71.9682 82.7502V94.1046Z",
    fill: "url(#paint5_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3037 88.4232L71.9683 94.1046V82.7502L82.3037 77.0687V88.4232Z",
    fill: "url(#paint6_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 82.7503L61.6328 77.0689L71.9682 71.3959L82.3037 77.0689L71.9682 82.7503Z",
    fill: "url(#paint7_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 82.7502L62.0764 77.3136L61.6328 77.5584L71.9682 83.2398L82.3037 77.5584V77.0687L71.9682 82.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 75.9548L21.3555 70.2733V81.6278L31.6909 87.3092L42.0263 81.6278V70.2733L31.6909 75.9548Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 87.3092L21.3555 81.6278V70.2733L31.6909 75.9548V87.3092Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 81.6278L31.6909 87.3092V75.9548L42.0263 70.2733V81.6278Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 75.9547L21.3555 70.2732L31.6909 64.5918L42.0263 70.2732L31.6909 75.9547Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 75.955L21.8079 70.5184L21.3555 70.7632L31.6909 76.4446L42.0263 70.7632L41.5827 70.5184L31.6909 75.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.2398L34.7783 77.5583V88.9212L45.1137 94.5942L55.4492 88.9212V77.5583L45.1137 83.2398Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 94.5942L34.7783 88.9212V77.5583L45.1137 83.2398V94.5942Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 88.9212L45.1138 94.5942V83.2398L55.4492 77.5583V88.9212Z",
    fill: "#2FD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.2398L34.7783 77.5584L45.1137 71.8854L55.4492 77.5584L45.1137 83.2398Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.24L35.2308 77.8118L34.7783 78.0566L45.1137 83.7296L55.4492 78.0566L55.0056 77.8118L45.1137 83.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5252L48.21 84.8522V96.2066L58.5454 101.888L68.8808 96.2066V84.8522L58.5454 90.5252Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 101.888L48.21 96.2066V84.8522L58.5454 90.5252V101.888Z",
    fill: "url(#paint8_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8808 96.2066L58.5454 101.888V90.5252L68.8808 84.8522V96.2066Z",
    fill: "url(#paint9_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5251L48.21 84.8521L58.5454 79.1707L68.8808 84.8521L58.5454 90.5251Z",
    fill: "url(#paint10_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 90.5252L48.6535 85.097L48.21 85.3418L58.5454 91.0233L68.8808 85.3418V84.8522L58.5454 90.5252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 83.7296L7.93311 78.0566V89.411L18.2685 95.0925L28.604 89.411V78.0566L18.2685 83.7296Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 95.0925L7.93311 89.411V78.0566L18.2685 83.7296V95.0925Z",
    fill: "url(#paint11_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0395 89.7656L11.1626 87.6382V83.375L15.0395 85.5024V89.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.604 89.411L18.2686 95.0925V83.7296L28.604 78.0566V89.411Z",
    fill: "url(#paint12_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 83.7299L7.93311 78.0569L18.2685 72.3754L28.604 78.0569L18.2685 83.7299Z",
    fill: "url(#paint13_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 83.7296L7.93311 78.0566V78.5462L18.2685 84.2277L28.604 78.5462L28.1515 78.3014L18.2685 83.7296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.0231L21.3555 85.3416V96.6961L31.6909 102.378L42.0263 96.6961V85.3416L31.6909 91.0231Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 102.378L21.3555 96.6961V85.3416L31.6909 91.0231V102.378Z",
    fill: "url(#paint14_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 96.6961L31.6909 102.378V91.0231L42.0263 85.3416V96.6961Z",
    fill: "url(#paint15_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.0232L21.3555 85.3418L31.6909 79.6688L42.0263 85.3418L31.6909 91.0232Z",
    fill: "url(#paint16_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 91.0231L21.3555 85.3416V85.8397L31.6909 91.5127L42.0263 85.8397L41.5827 85.5864L31.6909 91.0231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 98.309L34.7783 92.636L45.1137 86.9546L55.4492 92.636L45.1137 98.309Z",
    fill: "url(#paint17_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.9953 81.0534L64.9424 77.1785L71.9953 73.3037L79.0394 77.1785L71.9953 81.0534Z",
    fill: "#9F4BBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.2687 81.9482L11.2158 78.0733L18.2687 74.2069L25.3217 78.0733L18.2687 81.9482Z",
    fill: "#9F4BBE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 53.102L34.7783 47.4205V58.775L45.1137 64.4564L55.4492 58.775V47.4205L45.1137 53.102Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 64.4564L34.7783 58.775V47.4205L45.1137 53.102V64.4564Z",
    fill: "url(#paint18_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 58.775L45.1138 64.4564V53.102L55.4492 47.4205V58.775Z",
    fill: "url(#paint19_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 53.1021L34.7783 47.4206L45.1137 41.7476L55.4492 47.4206L45.1137 53.1021Z",
    fill: "url(#paint20_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 53.102L34.7783 47.4205V47.9102L45.1137 53.5916L55.4492 47.9102V47.4205L45.1137 53.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 60.3874L48.21 54.7144V66.0688L58.5454 71.7418L68.8808 66.0688V54.7144L58.5454 60.3874Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 71.7418L48.21 66.0688V54.7144L58.5454 60.3874V71.7418Z",
    fill: "url(#paint21_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8808 66.0688L58.5454 71.7418V60.3874L68.8808 54.7144V66.0688Z",
    fill: "url(#paint22_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 60.3874L48.21 54.7144L58.5454 49.033L68.8808 54.7144L58.5454 60.3874Z",
    fill: "url(#paint23_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 60.3874L48.21 54.7144V55.204L58.5454 60.877L68.8808 55.204V54.7144L58.5454 60.3874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 67.6812L61.6328 61.9998V73.3542L71.9682 79.0357L82.3037 73.3542V61.9998L71.9682 67.6812Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 79.0357L61.6328 73.3542V61.9998L71.9682 67.6812V79.0357Z",
    fill: "url(#paint24_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3037 73.3542L71.9683 79.0357V67.6812L82.3037 61.9998V73.3542Z",
    fill: "url(#paint25_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 67.6815L61.6328 62L71.9682 56.3186L82.3037 62L71.9682 67.6815Z",
    fill: "url(#paint26_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9682 67.6812L61.6328 61.9998V62.4894L71.9682 68.1708L82.3037 62.4894V61.9998L71.9682 67.6812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 60.877L21.3555 55.204V66.5584L31.6909 72.2399L42.0263 66.5584V55.204L31.6909 60.877Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 72.2399L21.3555 66.5584V55.204L31.6909 60.877V72.2399Z",
    fill: "url(#paint27_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 66.5584L31.6909 72.2399V60.877L42.0263 55.204V66.5584Z",
    fill: "url(#paint28_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 60.8771L21.3555 55.2041L31.6909 49.5226L42.0263 55.2041L31.6909 60.8771Z",
    fill: "url(#paint29_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 60.877L21.3555 55.204V55.6936L31.6909 61.3751L42.0263 55.6936V55.204L31.6909 60.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 68.6603L7.93311 62.9873V74.3418L18.2685 80.0148L28.604 74.3418V62.9873L18.2685 68.6603Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 80.0148L7.93311 74.3418V62.9873L18.2685 68.6603V80.0148Z",
    fill: "url(#paint30_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.604 74.3418L18.2686 80.0148V68.6603L28.604 62.9873V74.3418Z",
    fill: "url(#paint31_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 68.6605L7.93311 62.9875L18.2685 57.3061L28.604 62.9875L18.2685 68.6605Z",
    fill: "url(#paint32_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2685 68.6603L7.93311 62.9873V63.4769L18.2685 69.1584L28.604 63.4769V62.9873L18.2685 68.6603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.6911 89.3519L24.6382 85.477L31.6911 81.6106L38.744 85.477L31.6911 89.3519Z",
    fill: "#9F4BBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.5456 88.8624L51.4927 84.9875L58.5456 81.1127L65.5897 84.9875L58.5456 88.8624Z",
    fill: "#9F4BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.3481L34.7783 62.6751V74.0295L45.1137 79.711L55.4492 74.0295V62.6751L45.1137 68.3481Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 79.711L34.7783 74.0295V62.6751L45.1137 68.3481V79.711Z",
    fill: "url(#paint33_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 74.0295L45.1138 79.711V68.3481L55.4492 62.6751V74.0295Z",
    fill: "url(#paint34_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.3484L34.7783 62.6754L45.1137 56.9939L55.4492 62.6754L45.1137 68.3484Z",
    fill: "url(#paint35_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 68.3481L34.7783 62.6751V63.1647L45.1137 68.8462L55.4492 63.1647V62.6751L45.1137 68.3481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.6422L48.21 69.9607V81.3152L58.5454 86.9966L68.8808 81.3152V69.9607L58.5454 75.6422Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 86.9966L48.21 81.3152V69.9607L58.5454 75.6422V86.9966Z",
    fill: "url(#paint36_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8808 81.3152L58.5454 86.9966V75.6422L68.8808 69.9607V81.3152Z",
    fill: "url(#paint37_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.6423L48.21 69.9609L58.5454 64.2879L68.8808 69.9609L58.5454 75.6423Z",
    fill: "url(#paint38_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 75.6422L48.6535 70.2055L48.21 70.4588L58.5454 76.1318L68.8808 70.4588V69.9607L58.5454 75.6422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 76.1318L21.3555 70.4588V81.8132L31.6909 87.4862L42.0263 81.8132V70.4588L31.6909 76.1318Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 87.4862L21.3555 81.8132V70.4588L31.6909 76.1318V87.4862Z",
    fill: "url(#paint39_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 81.8132L31.6909 87.4862V76.1318L42.0263 70.4588V81.8132Z",
    fill: "url(#paint40_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 76.1318L21.3555 70.4588L31.6909 64.7773L42.0263 70.4588L31.6909 76.1318Z",
    fill: "url(#paint41_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 76.1318L21.3555 70.4588V70.9484L31.6909 76.6214L42.0263 70.9484V70.4588L31.6909 76.1318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.4256L34.7783 77.7442V89.0986L45.1137 94.7801L55.4492 89.0986V77.7442L45.1137 83.4256Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 94.7801L34.7783 89.0986V77.7442L45.1137 83.4256V94.7801Z",
    fill: "url(#paint42_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4492 89.0986L45.1138 94.7801V83.4256L55.4492 77.7442V89.0986Z",
    fill: "url(#paint43_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.4257L34.7783 77.7442L45.1137 72.0628L55.4492 77.7442L45.1137 83.4257Z",
    fill: "url(#paint44_radial_1652_7816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1137 83.4256L34.7783 77.7442V78.2338L45.1137 83.9153L55.4492 78.2338V77.7442L45.1137 83.4256Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4565L34.7793 36.775V48.1295L45.1147 53.8109L55.4501 48.1295V36.775L45.1147 42.4565Z",
    fill: "#42E8E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 53.8109L34.7793 48.1295V36.775L45.1147 42.4565V53.8109Z",
    fill: "#42E8E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4502 48.1295L45.1147 53.8109V42.4565L55.4502 36.775V48.1295Z",
    fill: "#2FD3C7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4565L34.7793 36.7751L45.1147 31.0936L55.4501 36.7751L45.1147 42.4565Z",
    fill: "#42E8E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4567L35.2317 37.0201L34.7793 37.2649L45.1147 42.9463L55.4501 37.2649L55.0066 37.0201L45.1147 42.4567Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 49.7417L48.2109 44.0603V55.4232L58.5464 61.0962L68.8818 55.4232V44.0603L58.5464 49.7417Z",
    fill: "#42E8E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 61.0962L48.2109 55.4232V44.0603L58.5464 49.7417V61.0962Z",
    fill: "#42E8E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8818 55.4232L58.5464 61.0962V49.7417L68.8818 44.0603V55.4232Z",
    fill: "#2FD3C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 49.7418L48.2109 44.0603L58.5464 38.3873L68.8818 44.0603L58.5464 49.7418Z",
    fill: "#42E8E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 49.742L48.6545 44.3138L48.2109 44.5586L58.5464 50.2316L68.8818 44.5586L68.4293 44.3138L58.5464 49.742Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 57.0275L61.6338 51.3545V62.7089L71.9692 68.3904L82.3046 62.7089V51.3545L71.9692 57.0275Z",
    fill: "#42E8E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 68.3904L61.6338 62.7089V51.3545L71.9692 57.0275V68.3904Z",
    fill: "url(#paint45_radial_1652_7816)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 57.0275L62.0774 51.5993L61.6338 51.8441L71.9692 57.5256L82.3046 51.8441V51.3545L71.9692 57.0275Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 50.2314L21.3555 44.5583V55.9128L31.6909 61.5858L42.0263 55.9128V44.5583L31.6909 50.2314Z",
    fill: "#42E8E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 61.5858L21.3555 55.9128V44.5583L31.6909 50.2314V61.5858Z",
    fill: "#42E8E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 55.9128L31.6909 61.5858V50.2314L42.0263 44.5583V55.9128Z",
    fill: "#2FD3C7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 50.2315L21.3555 44.5585L31.6909 38.877L42.0263 44.5585L31.6909 50.2315Z",
    fill: "#42E8E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 50.2316L21.8079 44.8034L21.3555 45.0482L31.6909 50.7296L42.0263 45.0482L41.5827 44.8034L31.6909 50.2316Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 57.5254L34.7793 51.844V63.1984L45.1147 68.8799L55.4501 63.1984V51.844L45.1147 57.5254Z",
    fill: "#42E8E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 68.8799L34.7793 63.1984V51.844L45.1147 57.5254V68.8799Z",
    fill: "#42E8E0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4502 63.1984L45.1147 68.8799V57.5254L55.4502 51.844V63.1984Z",
    fill: "#2FD3C7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 57.5254L34.7793 51.8439L45.1147 46.1709L55.4501 51.8439L45.1147 57.5254Z",
    fill: "#42E8E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 57.5254L35.2317 52.0887L34.7793 52.3336L45.1147 58.015L55.4501 52.3336L55.0066 52.0887L45.1147 57.5254Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 64.8108L48.2104 59.1378V70.4923L58.5459 76.1653L68.8813 70.4923V59.1378L58.5459 64.8108Z",
    fill: "#42E8E0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 76.1653L48.2104 70.4923V59.1378L58.5459 64.8108V76.1653Z",
    fill: "url(#paint46_radial_1652_7816)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 64.8108L48.654 59.3826L48.2104 59.6274L58.5459 65.3004L68.8813 59.6274V59.1378L58.5459 64.8108Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 58.0147L7.93262 52.3332V63.6961L18.268 69.3691L28.6035 63.6961V52.3332L18.268 58.0147Z",
    fill: "#42E8E0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6035 63.6961L18.2681 69.3691V58.0147L28.6035 52.3332V63.6961Z",
    fill: "url(#paint47_radial_1652_7816)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 58.0147L7.93262 52.3332V52.8313L18.268 58.5043L28.6035 52.8313L28.151 52.5865L18.268 58.0147Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 65.3091L21.3555 59.6277V70.9821L31.6909 76.6636L42.0263 70.9821V59.6277L31.6909 65.3091Z",
    fill: "#42E8E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 70.9821L31.6909 76.6636V65.3006L42.0263 59.6277V70.9821Z",
    fill: "url(#paint48_radial_1652_7816)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 65.3091L21.3555 59.6277V60.1173L31.6909 65.7987L42.0263 60.1173L41.5827 59.8725L31.6909 65.3091Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 72.5941L34.7788 66.9127V78.2672L45.1142 83.9486L55.4497 78.2672V66.9127L45.1142 72.5941Z",
    fill: "#42E8E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 72.5941L34.7788 66.9127V67.4108L45.1142 73.0838L55.4497 67.4108V66.9127L45.1142 72.5941Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 27.3789L34.7793 21.7059V33.0604L45.1147 38.7418L55.4501 33.0604V21.7059L45.1147 27.3789Z",
    fill: "#42E8E0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 38.7418L34.7793 33.0604V21.7059L45.1147 27.3789V38.7418Z",
    fill: "#42E8E0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4502 33.0604L45.1147 38.7418V27.3789L55.4502 21.7059V33.0604Z",
    fill: "#2FD3C7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 27.3792L34.7793 21.7062L45.1147 16.0247L55.4501 21.7062L45.1147 27.3792Z",
    fill: "#42E8E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 27.3792L35.2317 21.951L34.7793 22.1958L45.1147 27.8773L55.4501 22.1958L55.0066 21.951L45.1147 27.3792Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M45.1139 70.7456L38.0698 66.8707L45.1139 62.9959L52.1668 66.8707L45.1139 70.7456Z",
    fill: "#080344"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M31.6911 63.4517L24.6382 59.5853L31.6911 55.7104L38.744 59.5853L31.6911 63.4517Z",
    fill: "#080344"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.5451 62.9622L51.4922 59.0873L58.5451 55.2125L65.5892 59.0873L58.5451 62.9622Z",
    fill: "#080344"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.9948 55.2714L64.9419 51.3965L71.9948 47.5217L79.0389 51.3965L71.9948 55.2714Z",
    fill: "#080344"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.2683 56.1662L11.2153 52.2914L18.2683 48.4165L25.3212 52.2914L18.2683 56.1662Z",
    fill: "#080344"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 34.673L48.2109 28.9916V40.346L58.5464 46.0275L68.8818 40.346V28.9916L58.5464 34.673Z",
    fill: "#42E8E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 46.0275L48.2109 40.346V28.9916L58.5464 34.673V46.0275Z",
    fill: "#42E8E0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8818 40.346L58.5464 46.0275V34.673L68.8818 28.9916V40.346Z",
    fill: "#2FD3C7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 34.6733L48.2109 28.9918L58.5464 23.3188L68.8818 28.9918L58.5464 34.6733Z",
    fill: "#42E8E0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 34.673L48.6545 29.2363L48.2109 29.4896L58.5464 35.1626L68.8818 29.4896L68.4293 29.2363L58.5464 34.673Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 41.9584L61.6338 36.2854V47.6399L71.9692 53.3129L82.3046 47.6399V36.2854L71.9692 41.9584Z",
    fill: "#42E8E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 53.3129L61.6338 47.6399V36.2854L71.9692 41.9584V53.3129Z",
    fill: "url(#paint49_radial_1652_7816)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 41.9584L62.0774 36.5302L61.6338 36.775L71.9692 42.4565L82.3046 36.775V36.2854L71.9692 41.9584Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 35.1626L21.3555 29.4896V40.8441L31.6909 46.5171L42.0263 40.8441V29.4896L31.6909 35.1626Z",
    fill: "#42E8E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 46.5171L21.3555 40.8441V29.4896L31.6909 35.1626V46.5171Z",
    fill: "#42E8E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 40.8441L31.6909 46.5171V35.1626L42.0263 29.4896V40.8441Z",
    fill: "#2FD3C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 35.1626L21.3555 29.4896L31.6909 23.8082L42.0263 29.4896L31.6909 35.1626Z",
    fill: "#42E8E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 35.1629L21.8079 29.7347L21.3555 29.9795L31.6909 35.6609L42.0263 29.9795L41.5827 29.7347L31.6909 35.1629Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4565L34.7793 36.775V48.1295L45.1147 53.8109L55.4501 48.1295V36.775L45.1147 42.4565Z",
    fill: "#42E8E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 53.8109L34.7793 48.1295V36.775L45.1147 42.4565V53.8109Z",
    fill: "#42E8E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4502 48.1295L45.1147 53.8109V42.4565L55.4502 36.775V48.1295Z",
    fill: "#2FD3C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4565L34.7793 36.7751L45.1147 31.0936L55.4501 36.7751L45.1147 42.4565Z",
    fill: "#42E8E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1147 42.4567L35.2317 37.0201L34.7793 37.2649L45.1147 42.9463L55.4501 37.2649L55.0066 37.0201L45.1147 42.4567Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 49.7417L48.2104 44.0603V55.4232L58.5459 61.0962L68.8813 55.4232V44.0603L58.5459 49.7417Z",
    fill: "#42E8E0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 61.0962L48.2104 55.4232V44.0603L58.5459 49.7417V61.0962Z",
    fill: "url(#paint50_radial_1652_7816)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 49.7417L48.654 44.3136L48.2104 44.5584L58.5459 50.2314L68.8813 44.5584V44.0603L58.5459 49.7417Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 42.9462L7.93262 37.2647V48.6192L18.268 54.3007L28.6035 48.6192V37.2647L18.268 42.9462Z",
    fill: "#42E8E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6035 48.6192L18.2681 54.3007V42.9462L28.6035 37.2647V48.6192Z",
    fill: "url(#paint51_radial_1652_7816)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 42.9462L7.93262 37.2647V37.7628L18.268 43.4358L28.6035 37.7628L28.151 37.518L18.268 42.9462Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 50.2313L21.3555 44.5583V55.9128L31.6909 61.5858L42.0263 55.9128V44.5583L31.6909 50.2313Z",
    fill: "#42E8E0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 55.9128L31.6909 61.5858V50.2313L42.0263 44.5583V55.9128Z",
    fill: "url(#paint52_radial_1652_7816)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 50.2313L21.3555 44.5583V45.048L31.6909 50.7294L42.0263 45.048L41.5827 44.8032L31.6909 50.2313Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 57.5254L34.7788 51.844V63.1984L45.1142 68.8799L55.4497 63.1984V51.844L45.1142 57.5254Z",
    fill: "#42E8E0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6335 36.2858L71.9689 41.9588L82.3044 36.2858L71.9689 30.6043L61.6335 36.2858ZM61.6335 51.3544L71.9689 57.0274L82.3044 51.3544L71.9689 45.673L61.6335 51.3544ZM48.2106 59.1379L58.546 64.8109L68.8815 59.1379L58.546 53.4565L48.2106 59.1379ZM18.268 58.0152L7.93262 52.3337L18.268 46.6607L28.6035 52.3421L18.268 58.0152ZM21.3553 59.6277L31.6908 65.3007L42.0262 59.6277L31.6908 53.9463L21.3553 59.6277ZM45.1143 72.5944L34.7789 66.913L45.1143 61.24L55.4498 66.913L45.1143 72.5944ZM58.546 49.7423L48.2106 44.0608L58.546 38.3878L68.8815 44.0608L58.546 49.7423ZM7.93262 37.265L18.268 42.9465L28.6035 37.265L18.268 31.592L7.93262 37.265ZM31.6908 50.2317L21.3553 44.5587L31.6908 38.8772L42.0262 44.5587L31.6908 50.2317ZM34.7789 51.8439L45.1143 57.5254L55.4498 51.8439L45.1143 46.1709L34.7789 51.8439Z",
    fill: "#C9C8F8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 57.5254L34.7788 51.844V52.3336L45.1142 58.0151L55.4497 52.3421V51.844L45.1142 57.5254Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.9948 40.2699L64.9419 36.3951L71.9948 32.5202L79.0389 36.3951L71.9948 40.2699Z",
    fill: "#080344"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.2683 41.1648L11.2153 37.2899L18.2683 33.415L25.3212 37.2899L18.2683 41.1648Z",
    fill: "#080344"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 12.3102L34.7788 6.63722V17.9917L45.1142 23.6647L55.4497 17.9917V6.63722L45.1142 12.3102Z",
    fill: "#42E8E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 23.6647L34.7788 17.9917V6.63722L45.1142 12.3102V23.6647Z",
    fill: "url(#paint53_radial_1652_7816)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4497 17.9917L45.1143 23.6647V12.3102L55.4497 6.63722V17.9917Z",
    fill: "url(#paint54_radial_1652_7816)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 12.3102L34.7788 6.63722V7.12686L45.1142 12.8083L55.4497 7.12686V6.63722L45.1142 12.3102Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 19.6038L48.2104 13.9224V25.2768L58.5459 30.9583L68.8813 25.2768V13.9224L58.5459 19.6038Z",
    fill: "#42E8E0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 30.9583L48.2104 25.2768V13.9224L58.5459 19.6038V30.9583Z",
    fill: "url(#paint55_radial_1652_7816)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8813 25.2768L58.5459 30.9583V19.6038L68.8813 13.9224V25.2768Z",
    fill: "url(#paint56_radial_1652_7816)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 19.6038L48.2104 13.9224V14.412L58.5459 20.0935L68.8813 14.412V13.9224L58.5459 19.6038Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 26.8897L61.6338 21.2083V32.5712L71.9692 38.2442L82.3046 32.5712V21.2083L71.9692 26.8897Z",
    fill: "#42E8E0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 38.2442L61.6338 32.5712V21.2083L71.9692 26.8897V38.2442Z",
    fill: "url(#paint57_radial_1652_7816)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9692 26.8897L61.6338 21.2083V21.7063L71.9692 27.3793L82.3046 21.7063V21.2083L71.9692 26.8897Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 20.0936L21.3555 14.4121V25.775L31.6909 31.448L42.0263 25.775V14.4121L31.6909 20.0936Z",
    fill: "#42E8E0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 31.448L21.3555 25.775V14.4121L31.6909 20.0936V31.448Z",
    fill: "url(#paint58_radial_1652_7816)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 25.775L31.6909 31.448V20.0936L42.0263 14.4121V25.775Z",
    fill: "url(#paint59_radial_1652_7816)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 20.0936L21.3555 14.4121V14.9102L31.6909 20.5832L42.0263 14.9102V14.4121L31.6909 20.0936Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 27.8772L7.93262 22.1958V33.5502L18.268 39.2317L28.6035 33.5502V22.1958L18.268 27.8772Z",
    fill: "#42E8E0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6035 33.5502L18.2681 39.2317V27.8772L28.6035 22.1958V33.5502Z",
    fill: "url(#paint60_radial_1652_7816)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 27.8772L7.93262 22.1958V22.6939L18.268 28.3669L28.6035 22.6939V22.1958L18.268 27.8772Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.1149 55.854L38.0708 51.9792L45.1149 48.1127L52.1678 51.9792L45.1149 55.854Z",
    fill: "#080344"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.6911 48.5686L24.6382 44.6937L31.6911 40.8188L38.744 44.6937L31.6911 48.5686Z",
    fill: "#080344"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.5466 48.0703L51.4937 44.2039L58.5466 40.329L65.5906 44.2039L58.5466 48.0703Z",
    fill: "#080344"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 27.565L34.7788 21.8836V33.2381L45.1142 38.9195L55.4497 33.2381V21.8836L45.1142 27.565Z",
    fill: "#42E8E0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 38.9195L34.7788 33.2381V21.8836L45.1142 27.565V38.9195Z",
    fill: "url(#paint61_radial_1652_7816)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4497 33.2381L45.1143 38.9195V27.565L55.4497 21.8836V33.2381Z",
    fill: "url(#paint62_radial_1652_7816)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 27.565L34.7788 21.8836V22.3817L45.1142 28.0547L55.4497 22.3817V21.8836L45.1142 27.565Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 34.8502L48.2104 29.1772V40.5317L58.5459 46.2046L68.8813 40.5317V29.1772L58.5459 34.8502Z",
    fill: "#42E8E0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 46.2046L48.2104 40.5317V29.1772L58.5459 34.8502V46.2046Z",
    fill: "url(#paint63_radial_1652_7816)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5459 34.8502L48.654 29.422L48.2104 29.6668L58.5459 35.3483L68.8813 29.6668V29.1772L58.5459 34.8502Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 35.3485L21.3555 29.667V41.0215L31.6909 46.7029L42.0263 41.0215V29.667L31.6909 35.3485Z",
    fill: "#42E8E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0263 41.0215L31.6909 46.7029V35.3485L42.0263 29.667V41.0215Z",
    fill: "url(#paint64_radial_1652_7816)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 35.3485L21.3555 29.667V30.1567L31.6909 35.8381L42.0263 30.1567V29.667L31.6909 35.3485Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 42.6337L34.7788 36.9523V48.3152L45.1142 53.9882L55.4497 48.3152V36.9523L45.1142 42.6337Z",
    fill: "#42E8E0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3046 32.571L71.9691 38.244V26.8896L82.3046 21.2081V32.571ZM82.3046 47.6398L71.9691 53.3128V41.9584L82.3046 36.2854V47.6398ZM71.9691 68.3903L82.3046 62.7089V51.3544L71.9691 57.0274V68.3903ZM58.546 76.165L68.8815 70.492V59.1375L58.546 64.8105V76.165ZM18.268 69.3691L7.93262 63.6961V52.3332L18.268 58.0146V69.3691ZM21.3554 70.9818L31.6909 76.6632V65.3003L21.3554 59.6273V70.9818ZM45.1143 83.9484L34.779 78.2669V66.9125L45.1143 72.5939H45.1144L55.4498 66.9125V78.2669L45.1144 83.9484H45.1143ZM58.546 61.0962L68.8815 55.4232V44.0603L58.546 49.7417V61.0962ZM18.268 54.3004L7.93262 48.619V37.2645L18.268 42.946V54.3004ZM21.3554 55.9127L31.6909 61.5857V50.2313L21.3554 44.5583V55.9127ZM45.1143 68.8797L34.779 63.1983V51.8438L45.1143 57.5252H45.1144L55.4498 51.8438V63.1983L45.1144 68.8797H45.1143ZM7.93262 33.5499L18.268 39.2314V27.8769L7.93262 22.1955V33.5499ZM68.8815 40.5317L58.546 46.2047V34.8502L68.8815 29.1772V40.5317ZM21.3554 41.0214L31.6909 46.7029V35.3484L21.3554 29.667V41.0214ZM45.1143 53.988L34.779 48.315V36.9521L45.1143 42.6336H45.1144L55.4498 36.9521V48.315L45.1144 53.988H45.1143Z",
    fill: "url(#paint65_linear_1652_7816)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1143 12.3102L34.7789 6.63724L45.1143 0.955795L55.4498 6.63724L45.1143 12.3102ZM31.6908 35.3483L21.3553 29.6668L31.6908 23.9854L42.0262 29.6668L31.6908 35.3483ZM48.2106 13.9224L58.546 19.6039L68.8815 13.9224L58.546 8.24097L48.2106 13.9224ZM71.9689 26.8895L61.6335 21.2081L71.9689 15.5351L82.3044 21.2081L71.9689 26.8895ZM21.3553 14.4123L31.6908 20.0937L42.0262 14.4123L31.6908 8.73929L21.3553 14.4123ZM18.268 27.8769L7.93262 22.1954L18.268 16.5224L28.6035 22.1954L18.268 27.8769ZM34.7789 21.8834L45.1143 27.5649L55.4498 21.8834L45.1143 16.2104L34.7789 21.8834ZM58.546 34.85L48.2106 29.177L58.546 23.4956L68.8815 29.177L58.546 34.85ZM34.7789 36.9525L45.1143 42.6339L55.4498 36.9525L45.1143 31.2795L34.7789 36.9525Z",
    fill: "#C9C8F8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1142 42.6337L34.7788 36.9523V37.4504L45.1142 43.1234L55.4497 37.4504V36.9523L45.1142 42.6337Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.6652 72.8603) scale(80.0829 76.2046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1652_7816",
    x1: 0.458495,
    y1: 62.9127,
    x2: 90.4421,
    y2: 62.9127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3601,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7062,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.5432 64.4688) scale(86.261 82.0835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.92 91.0405) scale(93.803 89.2604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.92 91.0405) scale(93.8033 89.2605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6873) scale(98.0557 93.3071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5351 109.59) scale(52.8099 50.2525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.92 91.0405) scale(93.8029 89.2603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6873) scale(98.0561 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.535 109.59) scale(52.8099 50.2525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.92 91.0403) scale(93.8032 89.2604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.092 92.6875) scale(98.0562 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 75.9004) scale(104.937 99.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.92 91.0408) scale(93.8031 89.2604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0912 92.6871) scale(98.0557 93.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 75.8999) scale(104.938 99.8557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.919 91.0402) scale(93.8028 89.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.919 91.0406) scale(93.8029 89.2601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6874) scale(98.0563 93.3078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0207 75.9002) scale(104.937 99.8551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.254 50.7053) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6873) scale(98.0561 93.3074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0209 75.9003) scale(104.938 99.8556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7053) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6874) scale(98.0559 93.3072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5351 109.59) scale(52.8098 50.2523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7055) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0912 92.6873) scale(98.0557 93.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 75.9002) scale(104.938 99.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.254 50.7053) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.092 92.6871) scale(98.0561 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#843092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#723091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 75.9001) scale(104.937 99.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7053) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6872) scale(98.056 93.3073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0207 75.9001) scale(104.937 99.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7055) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0917 92.6874) scale(98.0562 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#D152DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#CA4BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#BC53D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D056DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.535 109.59) scale(52.8098 50.2523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7055) scale(177.324 168.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0912 92.6873) scale(98.0557 93.3071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 75.9003) scale(104.938 99.8556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.254 50.7052) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0916 92.6873) scale(98.056 93.3073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5349 109.59) scale(52.8097 50.2522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.255 50.7054) scale(177.38 168.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0926 51.9001) scale(98.0558 93.3071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.8999) scale(98.0523 93.3039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0204 35.1124) scale(104.937 99.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 35.1132) scale(104.937 99.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0926 51.8999) scale(98.0557 93.3071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.8998) scale(98.0561 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0204 35.113) scale(104.937 99.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 35.1126) scale(104.938 99.8557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.9) scale(98.0563 93.3077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0211 35.1128) scale(104.937 99.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.8996) scale(98.056 93.3073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0214 35.1126) scale(104.938 99.8556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0926 51.9002) scale(98.0558 93.3071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0912 51.8997) scale(98.0557 93.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 35.1127) scale(104.937 99.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0204 35.1129) scale(104.937 99.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.9002) scale(98.056 93.3074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0211 35.1131) scale(104.937 99.8551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.0921 51.8999) scale(98.0562 93.3075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    stopColor: "#D82D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#A82E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    stopColor: "#802F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    stopColor: "#612F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7291,
    stopColor: "#4B3092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8714,
    stopColor: "#3E3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_1652_7816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0208 35.113) scale(104.938 99.8558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    stopColor: "#F62F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2023,
    stopColor: "#C63EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#9E4BBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5413,
    stopColor: "#7F54C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#695BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1652_7816",
    x1: 0.895103,
    y1: 52.5783,
    x2: 91.5075,
    y2: 52.5783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C450B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AF25B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C1EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#821FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F17A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8C2DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatasetCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataset-card.1c4bae7e33be04588958945cd51019ea.svg";